export default () => ({
  entity: 'schedule',
  schedule: {
    id: null,
    date: null,
    time: null,
    patient: null,
    covenant: null,
    company: null
  }
})



// WEBPACK FOOTER //
// ./src/app/employee/dashboard/gadget/components/next-patient/resources/data.js